import { Offcanvas } from "react-bootstrap";
import { useCart } from "../../hooks";
import { CartProductList } from "..";

type Props = {
  show: boolean,
  handleClose: () => void
}

const CartView: React.FC<Props> = ({show, handleClose}) => {
  const { cartItems, cartQuantity } = useCart();

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end"  className="cart-offcanvas" >
       <div className="cart-offcanvas-inner">
      <Offcanvas.Header closeButton className="cart-sidebar-header">
        <Offcanvas.Title className="checkout-heading px-2 cart-sidebar-title">Your Order ({cartQuantity})</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="cart-sidebar-body common-cart-pd">
        <CartProductList cartItems={cartItems} editable={false} />
      </Offcanvas.Body>
      </div>
    </Offcanvas>
  )
}

export default CartView